// extracted by mini-css-extract-plugin
export var appeared = "Artwork-module--appeared--WxjkT";
export var artworkInfo = "Artwork-module--artworkInfo--hwl7j";
export var artworkText = "Artwork-module--artworkText--JXJLu";
export var back = "Artwork-module--back--KcLIi";
export var backInner = "Artwork-module--backInner--3yrHM";
export var flipButton = "Artwork-module--flipButton--PbK0d";
export var flipped = "Artwork-module--flipped--CxVsD";
export var front = "Artwork-module--front--hWcbZ";
export var headline = "Artwork-module--headline--A1whm";
export var imageWrapper = "Artwork-module--imageWrapper--+J2j3";
export var inner = "Artwork-module--inner---oTnw";
export var isInFlexLayout = "Artwork-module--isInFlexLayout--mX1sS";
export var root = "Artwork-module--root--LKk9x";
export var share = "Artwork-module--share--1hwrr";